import { ReactElement } from "react";

interface ToolSelectorButtonProps {
  toolName: string
  image?: string | null
  onClick: () => void
  className?: string

}

export function ToolSelectorButton({ toolName, image, onClick, className = "" }: ToolSelectorButtonProps): ReactElement {
  return (
    <button
      type="button"
      onClick={onClick}
      className="enlive-button d-flex flex-column justify-content-center align-items-center"
      style={{ width: "150px", height: "100px", color: "inherit" }}
    >
      {image != null && (
        <div className="mb-2 w-100 d-flex justify-content-center" style={{ height: "40px" }}>
          <img className="w-auto h-100" src={image} alt={"icon for " + toolName + " selection button."} />
        </div>
      )}

      <div className={`tool-selector-label ${className}`}>{toolName}</div>
    </button>
  );
}
